<template>
  <ul>
    <li v-for="review in reviews">
      <peer-review :review="review" :display="display" />
    </li>
  </ul>
</template>

<script>

  import PeerReview from "./peer-reviews/peer-review"

  export default {
    name: 'PeerReviews',
    components: { PeerReview },
    props: {
      reviews: {
        type: Array,
        required: true
      },
      display: {
        type: String,
        default: "received"
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  ul {
    @include list-style-reset;
  }

  li + li {
    margin-top:1rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/peer-reviews.vue